export enum CampaignState {
    Pending = "Pending",
    Paused = "Paused",
    Deleted = "Deleted",
    Declined = "Declined",
    Active = "Active",
    Completed = "Completed",
}